import { FormInitializerReturnType, numberSchema, ValidationMessageKeys } from 'src/Configuration/validation'
import { EmergencyPowerSettingsModel } from '../models'
import { SettingsFormModel } from '../models/settings-form.model'
import { boolean, lazy, number, object } from 'yup'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import modelToSettingsFormTransformer from '../transformers/model-to-settings-form.transformer'

const MIN_DELAY_NUMBER = 5
const MAX_DELAY_NUMBER = 60
const MIN_NUMBER = 0

/**
 *  Initializes the form for editing emergency power settings
 * @param model EmergencyPowerSettingsModel
 * @param showWallboxSettings boolean
 * @returns initialValues and validationSchema for emergencyPowerSettings form
 */
export const useEmergencyPowerSettingsFormInitializer = (
  model: EmergencyPowerSettingsModel,
  showWallboxSettings: boolean
): FormInitializerReturnType<SettingsFormModel, SettingsFormModel> => {
  const { t } = useCustomTranslation()
  const numberSchemaWithTranslation = numberSchema(t)

  const initialValues = modelToSettingsFormTransformer(model)

  /** Helper-Schema, to make the optional min-/max-epPower-fields readable */
  const minMaxNumberSchema = number()
    .min(model.wallbox.minBoundry, t(ValidationMessageKeys.min, { value: model.wallbox.minBoundry.toString() }))
    .max(model.wallbox.maxBoundry, t(ValidationMessageKeys.max, { value: model.wallbox.maxBoundry.toString() }))

  const validationSchema = object().shape({
    partialGrid: boolean().required(),
    delay: numberSchemaWithTranslation({ min: MIN_DELAY_NUMBER, max: MAX_DELAY_NUMBER }).required(),
    reserve: numberSchemaWithTranslation({ min: MIN_NUMBER, max: model.reserve.max }).required(),
    wallboxAllow: boolean().required(),
    wallboxMinEpPower: lazy(() => (showWallboxSettings ? minMaxNumberSchema.required() : minMaxNumberSchema)),
    wallboxMaxEpPower: lazy(() => (showWallboxSettings ? minMaxNumberSchema.required() : minMaxNumberSchema)),
    wallboxEnergy: numberSchemaWithTranslation({ min: MIN_NUMBER, max: model.reserve.max }).required(),
  })
  return { initialValues, validationSchema }
}
